import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { WorkflowStep, getStepNames } from '../../../store/Models/Api/SftpImportModels';

interface WorkflowStepperLocalProps {
    steps: WorkflowStep[];
    currentStep: WorkflowStep;
    maxStepReached: WorkflowStep;
    isCurrentStepValid: () => boolean;
    setStep: (step: WorkflowStep) => void;
}

type WorkflowStepperProps = WorkflowStepperLocalProps & ToxnotComponentProperties;

class WorkflowStepperComponent extends ToxnotComponent<WorkflowStepperProps> {

    render() {
        const { steps, currentStep, maxStepReached, isCurrentStepValid, setStep, appServices } = this.props;
        const stepNames = getStepNames(appServices);
        const currentIndex = steps.indexOf(currentStep);
        const maxIndex = steps.indexOf(maxStepReached);

        const handleSetStep = (step: WorkflowStep) => {
            if (isCurrentStepValid()) {
                setStep(step);
            }
        };

        return (
            <div className="tow-sequence-diagram">
                <button type="button" className="btn btn-sm btn-toxnot-tow-nav-button tow-bump-button"
                    disabled={currentIndex === 0 || !isCurrentStepValid()}
                    onClick={() => handleSetStep(steps[currentIndex - 1])}>
                    <span className="glyphicon glyphicon-chevron-left"></span>
                </button>            {steps.map((step, index) => {
                const isActive = index === currentIndex;
                const isClickable = index <= maxIndex && isCurrentStepValid();
                const isPreviousStep = index === currentIndex - 1;

                const stepClassName = `tow-step-body ${isActive ? 'tow-step-active' : ''}`;

                return (
                    <div className="tow-tab-step" key={step} onClick={() => isClickable && handleSetStep(step)}>
                        {index === 0 && <div className="tow-step-start-cap"></div>}
                        <div className={stepClassName} data-key={step}>
                            {stepNames[step]}
                        </div>
                        {index < steps.length - 1 ?
                            <div className="tow-step-join">
                                <svg style={{ width: "10px", height: "100%" }}><use href={isActive ? "#step-active-left"  : (isPreviousStep ? "#step-active-right" : "#step-active-neither")}></use></svg>
                            </div>
                            : <div className="tow-step-end-cap"></div>
                        }
                    </div>
                );
            })}

            <button type="button" className="btn btn-sm btn-toxnot-tow-nav-button tow-bump-button"
                disabled={currentIndex === steps.length - 1 || !isCurrentStepValid() || currentStep === WorkflowStep.DefaultHandling}
                onClick={() => handleSetStep(steps[currentIndex + 1])}>
                <span className="glyphicon glyphicon-chevron-right"></span>
            </button>
        </div>
    );
    }
}

export const WorkflowStepper = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(WorkflowStepperComponent);
